import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=32d20b00&scoped=true"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"
import style0 from "./Customers.vue?vue&type=style&index=0&id=32d20b00&prod&lang=scss"
import style1 from "./Customers.vue?vue&type=style&index=1&id=32d20b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d20b00",
  null
  
)

export default component.exports